/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Tipologia di convenzione applicata al voucher
 */
export enum TipoConvenzione {

    COMUNE = 'COMUNE',

    COOPLIMPRONTA = 'COOPLIMPRONTA',

    COMUNE_GIA_STIPULATA = 'COMUNE_GIA_STIPULATA',

    COMUNE_DA_STIPULARE = 'COMUNE_DA_STIPULARE'
}

